import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Box, Button, Stack, TextField, Typography, CircularProgress } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import { SETTING_TABLE_NAME } from "Constants/settingsTableName";
import { useMsal } from "Auth/msal-context";
import { useKeyboard } from "../../../hooks/KeyboardContext";
import useSettings from "../../../hooks/useSettings";

const SO2ScrubberSettings = () => {
  const { t } = useTranslation("common");
  const { isAuthorized, isEdge } = useMsal();
  const { registerInput } = useKeyboard();

  const { formState, updateField, loading, error, fetchSettings, saveSettings } =
    useSettings(SETTING_TABLE_NAME.SO2_SCRUBBER_SETTINGS);

  const handleSave = () => {
    if (formState) saveSettings({ interval: formState.interval });
  };

  return (
    <Accordion sx={{ mb: 2 }} disableGutters onChange={(e, expanded) => { if (expanded) fetchSettings(); }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ bgcolor: "primary.main", color: "common.white" }}>
        <Typography sx={{ fontWeight: "bold", fontSize: "1.5rem" }}>SO2 Scrubber</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ bgcolor: "background.light", p: 2 }}>
        {loading && <CircularProgress size={24} />}
        {error && (
          <Typography sx={{ textAlign: "center", color: "secondary.main" }}>
            {t("No Settings Found")}
          </Typography>
        )}
        {!loading && formState && (
          <Stack direction="row" spacing={2} sx={{ alignItems: "center", justifyContent: "center" }}>
            <Typography>{t("Interval")} {t("Minutes")}</Typography>
            <TextField
              size="small"
              value={formState.interval ?? ""}
              onChange={(e) => updateField("interval", e.target.value)}
              onClick={(e) => registerInput("interval", formState.interval, (v) => updateField("interval", v))}
              error={formState.interval !== "" && formState.interval != null && isNaN(Number(String(formState.interval).replace(",", ".")))}
              helperText={formState.interval !== "" && formState.interval != null && isNaN(Number(String(formState.interval).replace(",", "."))) ? "Input a number" : ""}
              sx={{ width: 100 }}
            />
          </Stack>
        )}
        {(isAuthorized || isEdge) && formState && (
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button variant="contained" size="small" onClick={handleSave}>{t("Save")}</Button>
          </Box>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SO2ScrubberSettings;
